const clouds = [
    {
        path: '/:project_id/kubernetes/clusters',
        name: 'kubernetes.clusters',
        component: () => import('@/pages/Kubernetes/Cluster/IndexPage.vue'),
        meta: {
            requiresAuth: true,
            need_project: true,
            is_vpc: true,
            layout: 'content',
            title: "Clusters",
        }
    },
    {
        path: '/:project_id/kubernetes/clusters/create',
        name: 'kubernetes.clusters.create',
        component: () => import('@/pages/Kubernetes/Cluster/CreatePage.vue'),
        meta: {
            requiresAuth: true,
            need_project: true,
            is_vpc: true,
            layout: 'content',
            title: "Create a Cluster",
        }
    },
]

export default clouds